import React from "react";
import ConnectedAttachmentWithFeedback from "./Feedback/ConnectedAttachmentWithFeedback";
import ConnectedAttachmentWithLiveChat from "./LiveChat/ConnectedAttachmentWithLiveChat";
import ConnectedAttachmentWithWelcomeMessage from "./ArpWelcomeMessage/ConnectedAttachmentWithWelcomeMessage";
import ConnectedAttachmentWithPasscode from "./ResetPassword/ConnectedAttachmentWithPasscode";
import ConnectedAttachmentWithPassword from "./ResetPassword/ConnectedAttachmentWithPassword";
import ConnectedAttachmentWithUsernameDob from "./ResetPassword/ConnectedAttachmentWithUsernameDob";
import ConnectedAttachmentWithOtpType from "./ResetPassword/ConnectedAttachementWithOtpType";
import ConnectedAttachmentWithEmailDob from "./ResetPassword/ConnectedAttachmentWithEmailDob";
import ConnectedAttachmentWithContactUs from "./ResetPassword/ConnectedAttachmentWithContactUs";
import ConnectedAttachmentWithLiveChat1 from "./LiveChat/ConnectedAttachmentWithLiveChat1.js";
import ConnectedAttachmentWithLiveChat2 from "./LiveChat/ConnectedAttachmentWithLiveChat2.js";
import useChatbot from "../../Hooks/useChatbot";

const attachmentMiddleware = () => (next) => (card) => {
  const { openPasswordResetWizard, setCurrentPage } = useChatbot();
  const welcomeRole = card.activity.from.role === "user";
  if (
    card.activity.type !== "typing" &&
    !welcomeRole &&
    card.activity.hasOwnProperty("entities") &&
    card.activity.entities[0].type === "welcomeMessageARP"
  ) {
    return (
      <ConnectedAttachmentWithWelcomeMessage activity={card.activity}>
        {next(card)}
      </ConnectedAttachmentWithWelcomeMessage>
    );
  }

  if (
    card.attachment &&
    card.attachment.contentType === "application/liveChatCard"
  ) {
    return (
      <ConnectedAttachmentWithLiveChat activity={card.activity}>
        {next(card)}
      </ConnectedAttachmentWithLiveChat>
    );
  }

  if (
    card.attachment &&
    card.attachment.contentType === "application/feedbackcard"
  ) {
    return (
      <ConnectedAttachmentWithFeedback activity={card.activity}>
        {next(card)}
      </ConnectedAttachmentWithFeedback>
    );
  }

  if (
    card.attachment &&
    card.attachment.contentType === "application/liveChatCard1"
  ) {
    return (
      <ConnectedAttachmentWithLiveChat1 activity={card.activity}>
        {next(card)}
      </ConnectedAttachmentWithLiveChat1>
    );
  }

  if (
    card.attachment &&
    card.attachment.contentType === "application/liveChatCard2"
  ) {
    return (
      <ConnectedAttachmentWithLiveChat2 activity={card.activity}>
        {next(card)}
      </ConnectedAttachmentWithLiveChat2>
    );
  }

  return next(card);
};

export default attachmentMiddleware;
